{
  "accountantActivity": {
    "title": "Hoạt động kế toán",
    "subtitle": "Audit SoD hằng ngày — khối lượng thao tác tiền tệ của từng kế toán/admin so với trung bình 30 ngày (cắm cờ: >10x trung bình và >=5 thao tác)",
    "redFlagOnly": "Chỉ cờ đỏ",
    "loading": "Đang tải…",
    "empty": "Chưa có báo cáo — cron audit 02:00 UTC ghi mỗi ngày một báo cáo",
    "emptyDetail": "Không có hoạt động nào được ghi nhận trong ngày này",
    "detailTitle": "Chi tiết báo cáo — {{date}}",
    "flaggedGeneric": "bị cắm cờ",
    "columns": {
      "date": "Ngày",
      "generatedAt": "Tạo lúc",
      "totalEvents": "Tổng sự kiện",
      "redFlags": "Cờ đỏ",
      "digestRecipients": "Đã gửi digest",
      "user": "Người dùng",
      "role": "Vai trò",
      "creditMemos": "Credit memo",
      "markPaid": "Mark paid",
      "refundTasks": "Refund task",
      "total": "Tổng",
      "baseline": "Trung bình 30 ngày",
      "flagged": "Cắm cờ"
    }
  },
  "auth": {
    "login": {
      "title": "Chào mừng trở lại",
      "subtitle": "Đăng nhập vào tài khoản của bạn",
      "lockout": {
        "before": "Tài khoản đang khoá. Mở lại sau"
      },
      "emailLabel": "Email",
      "emailPlaceholder": "ten@congty.com",
      "passwordLabel": "Mật khẩu",
      "passwordPlaceholder": "Nhập mật khẩu của bạn",
      "showPassword": "Hiện mật khẩu",
      "hidePassword": "Ẩn mật khẩu",
      "forgotPassword": "Quên mật khẩu?",
      "submit": "Đăng nhập",
      "submitting": "Đang đăng nhập…",
      "or": "HOẶC",
      "continueLark": "Tiếp tục với Lark Suite",
      "noRegisterNotice": "Tài khoản admin chỉ được cấp bởi Superadmin.",
      "validation": {
        "emailInvalid": "Email không hợp lệ",
        "passwordMin": "Mật khẩu (password) tối thiểu 8 ký tự",
        "passwordMax": "Mật khẩu (password) tối đa 128 ký tự"
      },
      "stepUp": {
        "prompt": "Vì lý do bảo mật, vui lòng nhập mã OTP đã gửi tới email của bạn.",
        "otpLabel": "Mã OTP (6 chữ số)",
        "otpInvalid": "Mã OTP phải gồm 6 chữ số.",
        "otpWrong": "Mã OTP không đúng hoặc đã hết hạn.",
        "verify": "Xác thực OTP",
        "cancel": "Hủy"
      },
      "errors": {
        "invalidCredentials": "Email hoặc mật khẩu không đúng.",
        "recaptchaFailed": "reCAPTCHA (cơ chế chống bot) thất bại — vui lòng thử lại.",
        "emailUnverified": "Email chưa xác thực. Liên hệ Superadmin.",
        "twoFaRequired": "Cần xác thực 2 lớp (2FA) — nhập mã từ ứng dụng Authenticator.",
        "accountLocked": "Tài khoản tạm khoá do nhiều lần đăng nhập sai. Vui lòng đợi vài phút và thử lại.",
        "accountLockedCountdown": "Tài khoản tạm khoá do nhiều lần đăng nhập sai. Mở khoá sau {{time}}.",
        "pendingApproval": "Tài khoản vendor đang chờ admin duyệt.",
        "rateLimit": "Quá nhiều lần thử — vui lòng đợi 15 phút.",
        "validationFailed": "Dữ liệu nhập chưa hợp lệ.",
        "authRequired": "Vui lòng đăng nhập để tiếp tục.",
        "forbidden": "Tài khoản không có quyền truy cập.",
        "default": "Đăng nhập thất bại. Vui lòng thử lại."
      }
    },
    "forgot": {
      "title": "Quên mật khẩu",
      "subtitle": "Nhập email tài khoản — chúng tôi sẽ gửi liên kết đặt lại mật khẩu.",
      "emailLabel": "Email",
      "emailPlaceholder": "ban@congty.com",
      "submit": "Gửi liên kết đặt lại",
      "submitting": "Đang gửi...",
      "backToLogin": "Quay lại đăng nhập",
      "validation": {
        "emailInvalid": "Email không hợp lệ"
      },
      "success": {
        "title": "Kiểm tra hộp thư",
        "descBefore": "Nếu",
        "descAfter": "đã đăng ký, bạn sẽ nhận được liên kết đặt lại mật khẩu trong vài phút. Liên kết có hiệu lực trong 15 phút."
      }
    },
    "reset": {
      "title": "Đặt mật khẩu mới",
      "subtitle": "Mật khẩu phải đáp ứng tất cả các yêu cầu bên dưới.",
      "newPasswordLabel": "Mật khẩu mới",
      "confirmPasswordLabel": "Xác nhận mật khẩu",
      "rulesAria": "Yêu cầu mật khẩu",
      "submit": "Đặt mật khẩu mới",
      "submitting": "Đang xử lý...",
      "backToLogin": "Quay lại đăng nhập",
      "rules": {
        "len": "Ít nhất 12 ký tự",
        "upper": "Có ít nhất 1 chữ in hoa",
        "num": "Có ít nhất 1 chữ số",
        "special": "Có ít nhất 1 ký tự đặc biệt"
      },
      "validation": {
        "lenMin": "Mật khẩu phải có ít nhất 12 ký tự",
        "upper": "Cần ít nhất 1 chữ in hoa",
        "num": "Cần ít nhất 1 chữ số",
        "special": "Cần ít nhất 1 ký tự đặc biệt",
        "confirmRequired": "Vui lòng xác nhận mật khẩu",
        "mismatch": "Mật khẩu xác nhận không khớp"
      },
      "flash": {
        "title": "Đặt lại mật khẩu thành công",
        "desc": "Vui lòng đăng nhập bằng mật khẩu mới."
      },
      "errors": {
        "reused": "Mật khẩu đã được sử dụng gần đây. Vui lòng chọn mật khẩu khác.",
        "requestFailed": "Yêu cầu thất bại (HTTP {{status}})",
        "unknown": "Lỗi không xác định"
      },
      "invalid": {
        "title": "Liên kết không hợp lệ",
        "desc": "Liên kết đặt lại đã được sử dụng hoặc hết hạn (15 phút). Vui lòng yêu cầu liên kết mới.",
        "requestNew": "Yêu cầu liên kết mới"
      },
      "validating": "Đang kiểm tra liên kết đặt lại…"
    },
    "verify2fa": {
      "title": "Xác thực 2 bước (Admin)",
      "headlineEmail": "Nhập mã OTP được gửi tới email",
      "headlineTotp": "Nhập mã từ ứng dụng xác thực (TOTP — Time-based One-Time Password)",
      "codeLabel": "Mã 6 chữ số",
      "codeAria": "Mã 6 chữ số",
      "trustDevice": "Tin tưởng thiết bị này 30 ngày",
      "submit": "Xác nhận",
      "submitting": "Đang xác thực…",
      "backToLogin": "Quay lại đăng nhập",
      "recoveryHint": "Mất thiết bị xác thực? Liên hệ Superadmin để khôi phục.",
      "errors": {
        "incomplete": "Vui lòng nhập đủ 6 chữ số.",
        "sessionExpired": "Phiên xác thực đã hết hạn — vui lòng đăng nhập lại.",
        "expired": "Mã đã hết hạn — vui lòng đăng nhập lại.",
        "tooMany": "Quá nhiều lần thử — vui lòng đợi 15 phút.",
        "invalid": "Mã xác thực không đúng."
      }
    }
  },
  "setup": {
    "wizard": {
      "title": "Printway — Thiết lập ban đầu",
      "subtitle": "Hoàn thành 3 bước để khởi tạo tài khoản Super Admin",
      "progressAria": "Tiến độ thiết lập",
      "steps": {
        "step1": "Tạo Super Admin",
        "step2": "Bật 2FA (xác thực 2 lớp)",
        "step3": "Mã khôi phục"
      }
    },
    "createAdmin": {
      "heading": "Bước 1 — Tạo tài khoản Super Admin",
      "descriptionBefore": "Tài khoản này sẽ là chủ sở hữu hệ thống. Email phải sử dụng tên miền nội bộ",
      "descriptionAfter": ".",
      "emailLabel": "Email Super Admin",
      "nameLabel": "Tên hiển thị",
      "namePlaceholder": "Founding Admin",
      "passwordLabel": "Mật khẩu",
      "passwordHint": "Tối thiểu 12 ký tự (theo chính sách).",
      "confirmPasswordLabel": "Nhập lại mật khẩu",
      "acceptTerms": "Tôi đồng ý với điều khoản dịch vụ Printway và chịu trách nhiệm quản lý tài khoản Super Admin này.",
      "submit": "Tiếp tục → Bước 2",
      "submitting": "Đang tạo…",
      "validation": {
        "emailRequired": "Email là bắt buộc",
        "emailInvalid": "Email không hợp lệ",
        "emailDomain": "Email phải kết thúc bằng @printway.work",
        "nameRequired": "Tên hiển thị là bắt buộc",
        "passwordMin": "Mật khẩu phải có ít nhất 12 ký tự",
        "passwordMax": "Mật khẩu không được vượt quá 128 ký tự",
        "acceptTermsRequired": "Bạn phải đồng ý với điều khoản dịch vụ",
        "passwordMismatch": "Mật khẩu nhập lại không khớp"
      },
      "errors": {
        "missingToken": "Thiếu setup token (mã thiết lập). Mở lại liên kết được cấp khi triển khai.",
        "createFailed": "Không thể tạo Super Admin — vui lòng thử lại"
      }
    },
    "enable2fa": {
      "heading": "Bước 2 — Bật xác thực 2 lớp (2FA)",
      "descriptionBefore": "Quét mã QR bằng ứng dụng Authenticator (Google Authenticator, 1Password, Authy…) rồi nhập mã 6 chữ số để xác nhận. Bước này ",
      "descriptionRequired": "bắt buộc",
      "descriptionAfter": ".",
      "qrAlt": "Mã QR TOTP (mã QR để cấu hình ứng dụng Authenticator)",
      "qrGenerating": "Đang tạo mã QR…",
      "qrError": "Không thể tạo mã QR — dùng manual key bên dưới.",
      "manualKeyLabel": "Manual key (mã nhập tay nếu không quét được QR):",
      "manualKeyMissing": "(Chưa có manual key — quét mã QR ở trên)",
      "accountLabel": "Tài khoản: {{email}}",
      "emailUnknown": "(không rõ)",
      "issuerLabel": "Issuer:",
      "totpCodeLabel": "Mã xác thực 6 chữ số",
      "submit": "Xác minh → Bước 3",
      "submitting": "Đang xác minh…",
      "validation": {
        "totpFormat": "Mã TOTP phải gồm đúng 6 chữ số"
      },
      "errors": {
        "missingSetupToken": "Thiếu setup token (mã thiết lập) — quay lại bước 1 và thử lại.",
        "missingEnrollToken": "Thiếu enrollment token (mã đăng ký TOTP) — quay lại bước 1 và thử lại.",
        "verifyFailed": "Mã TOTP không đúng — vui lòng thử lại"
      }
    },
    "recoveryCodes": {
      "heading": "Bước 3 — Mã khôi phục",
      "descriptionBefore": "Đây là 8 mã khôi phục một lần (recovery codes — dùng khi mất thiết bị 2FA). ",
      "descriptionStrong": "Chỉ hiển thị lần này",
      "descriptionAfter": ". Tải xuống và lưu offline ở nơi an toàn (két, password manager).",
      "generating": "Đang sinh mã khôi phục…",
      "download": "Tải xuống recovery-codes.txt",
      "ackStrong": "Đã lưu ở nơi an toàn.",
      "ackRest": " Tôi hiểu rằng mã khôi phục sẽ không hiển thị lại — nếu mất, tôi sẽ phải reset 2FA qua quy trình hỗ trợ.",
      "complete": "Hoàn tất → Đăng nhập",
      "completing": "Đang chuyển…",
      "errors": {
        "missingToken": "Thiếu token thiết lập — quay lại bước 1 và thử lại từ đầu.",
        "loadFailed": "Không tải được mã khôi phục — vui lòng thử lại"
      },
      "bannerTitle": "Printway — Recovery Codes (Mã khôi phục Super Admin)",
      "bannerNote": "Lưu file này ở nơi an toàn (offline). Mỗi mã chỉ dùng được 1 lần."
    },
    "errors": {
      "httpFailed": "Yêu cầu thất bại (HTTP {{status}})"
    }
  },
  "profile": {
    "account": {
      "title": "Tài khoản của tôi",
      "subtitle": "Quản lý thông tin cá nhân, bảo mật và phiên đăng nhập.",
      "tabsAria": "Mục tài khoản",
      "formAria": "Biểu mẫu hồ sơ",
      "loading": "Đang tải thông tin tài khoản…",
      "loadError": "Lỗi tải tài khoản",
      "tabs": {
        "profile": "Hồ sơ",
        "security": "Bảo mật",
        "notifications": "Thông báo",
        "preferences": "Tùy chọn",
        "activity": "Hoạt động"
      },
      "fields": {
        "email": "Email",
        "role": "Vai trò",
        "firstName": "Tên",
        "lastName": "Họ",
        "phone": "Số điện thoại",
        "country": "Quốc gia",
        "avatarUrl": "Ảnh đại diện (URL)"
      },
      "emailReadonly": "Email không thể chỉnh sửa.",
      "saveErrorFallback": "Lỗi lưu thay đổi",
      "saveSuccess": "Đã lưu thay đổi.",
      "save": "Lưu thay đổi",
      "saving": "Đang lưu…",
      "security": {
        "passwordTitle": "Đổi mật khẩu",
        "passwordDesc": "Đổi mật khẩu bằng cách nhập mật khẩu hiện tại và mật khẩu mới.",
        "changePassword": "Đổi mật khẩu",
        "twoFactorTitle": "Xác thực hai bước (2FA)",
        "twoFactorStatus": "Trạng thái:",
        "twoFactorOn": "Đang bật",
        "twoFactorOff": "Chưa bật",
        "twoFactorDesc": "Bật xác thực hai bước để tăng bảo mật cho tài khoản (chọn TOTP hoặc mã OTP qua email).",
        "sessionsTitle": "Phiên đăng nhập",
        "manageSessions": "Quản lý phiên đăng nhập",
        "enableTwoFactor": "Bật 2FA",
        "manageTwoFactor": "Quản lý 2FA"
      },
      "notifications": {
        "category": "Loại",
        "quietHours": "Giờ im lặng",
        "quietHoursDesc": "Tạm dừng thông báo đẩy trong khung giờ này.",
        "channels": {
          "email": "Email",
          "push": "Đẩy",
          "in_app": "Trong ứng dụng"
        },
        "categories": {
          "orders": "Đơn hàng",
          "shipping": "Vận chuyển",
          "payment": "Thanh toán",
          "wallet": "Ví",
          "billing": "Hóa đơn",
          "system": "Hệ thống",
          "marketing": "Tiếp thị"
        },
        "testEmail": "Email thử nghiệm",
        "testEmailDesc": "Gửi một email thông báo mẫu đến địa chỉ tài khoản của bạn.",
        "testEmailSend": "Gửi email thử nghiệm",
        "testEmailSending": "Đang gửi…",
        "testEmailSent": "Đã gửi email thử nghiệm. Kiểm tra hộp thư của bạn.",
        "testEmailNotSent": "Không thể gửi email thử nghiệm. Vui lòng thử lại.",
        "testEmailError": "Không thể gửi email thử nghiệm. Vui lòng thử lại."
      },
      "preferences": {
        "groups": {
          "regional": "Khu vực",
          "display": "Hiển thị",
          "email": "Email"
        },
        "fields": {
          "language": "Ngôn ngữ",
          "currency": "Tiền tệ",
          "dateFormat": "Định dạng ngày",
          "timezone": "Múi giờ",
          "theme": "Giao diện",
          "density": "Mật độ",
          "dashboardView": "Chế độ dashboard",
          "emailDigest": "Email tóm tắt"
        },
        "options": {
          "theme": {
            "system": "Hệ thống",
            "light": "Sáng",
            "dark": "Tối",
            "auto": "Tự động"
          },
          "density": {
            "normal": "Bình thường",
            "compact": "Gọn"
          },
          "dashboardView": {
            "expanded": "Mở rộng",
            "compact": "Gọn"
          },
          "emailDigest": {
            "none": "Không",
            "daily": "Hàng ngày",
            "weekly": "Hàng tuần",
            "monthly": "Hàng tháng"
          }
        },
        "descriptions": {
          "regional": "Ngôn ngữ, tiền tệ và định dạng ngày giờ.",
          "display": "Giao diện hiển thị."
        },
        "themeHints": {
          "light": "Giao diện sáng",
          "dark": "Giao diện tối",
          "system": "Theo cài đặt máy",
          "auto": "Sáng 6:00–18:00, tối sau đó"
        }
      },
      "activity": {
        "empty": "Chưa có hoạt động tài khoản gần đây."
      }
    },
    "sessions": {
      "title": "Phiên đăng nhập đang hoạt động",
      "subtitle": "Danh sách thiết bị / trình duyệt đang truy cập tài khoản của bạn.",
      "tableAria": "Phiên đang hoạt động",
      "revokeAll": "Thu hồi tất cả",
      "revokingAll": "Đang thu hồi…",
      "revokeOneSuccess": "Đã thu hồi phiên đăng nhập.",
      "revokeOneError": "Lỗi thu hồi phiên",
      "revokeAllSuccess_one": "Đã thu hồi {{count}} phiên.",
      "revokeAllSuccess_other": "Đã thu hồi {{count}} phiên.",
      "revokeAllError": "Lỗi thu hồi tất cả phiên",
      "loading": "Đang tải phiên…",
      "loadError": "Lỗi tải danh sách phiên",
      "empty": "Không tìm thấy phiên đăng nhập nào.",
      "columns": {
        "device": "Thiết bị",
        "ip": "IP",
        "start": "Bắt đầu",
        "lastSeen": "Hoạt động cuối",
        "actions": "Hành động"
      },
      "currentBadge": "Phiên hiện tại",
      "emptyUserAgent": "User-Agent rỗng",
      "revoke": "Thu hồi",
      "revoking": "Đang thu hồi…",
      "deviceLabels": {
        "unknown": "Không xác định",
        "browser": "Trình duyệt"
      },
      "browserLabels": {
        "other": "Khác"
      },
      "activeTitle": "Phiên đang hoạt động",
      "activeSubtitle": "Các thiết bị đang đăng nhập vào tài khoản của bạn. Thu hồi bất kỳ phiên nào bạn không nhận ra.",
      "deviceOn": "trên",
      "signOut": "Đăng xuất"
    },
    "preferences": {
      "title": "Thiết lập cá nhân",
      "subtitle": "Tuỳ chỉnh giao diện, ngôn ngữ, múi giờ và thông báo.",
      "formAria": "Biểu mẫu thiết lập",
      "loading": "Đang tải thiết lập…",
      "loadError": "Lỗi tải thiết lập",
      "theme": {
        "legend": "Giao diện",
        "light": "Sáng",
        "dark": "Tối",
        "system": "Theo hệ thống"
      },
      "language": {
        "label": "Ngôn ngữ"
      },
      "timezone": {
        "label": "Múi giờ"
      },
      "dateFormat": {
        "label": "Định dạng ngày"
      },
      "notifications": {
        "legend": "Thông báo",
        "emailLabel": "Nhận email",
        "emailDesc": "Thông báo không bắt buộc; email giao dịch (đặt lại mật khẩu, 2FA) luôn được gửi.",
        "smsLabel": "Nhận SMS"
      },
      "saveErrorFallback": "Lỗi lưu thiết lập",
      "saveSuccess": "Đã lưu thiết lập.",
      "save": "Lưu thiết lập",
      "saving": "Đang lưu…"
    },
    "loginHistory": {
      "title": "Lịch sử đăng nhập",
      "tableAria": "Lịch sử đăng nhập",
      "subtitle": "Các lần đăng nhập thành công và thất bại gần đây trên tài khoản của bạn.",
      "columns": {
        "status": "Trạng thái",
        "ts": "Thời gian",
        "ip": "IP",
        "device": "Thiết bị",
        "browser": "Trình duyệt",
        "reason": "Lý do"
      },
      "filter": {
        "from": "Từ ngày",
        "to": "Đến ngày"
      },
      "loading": "Đang tải…",
      "loadError": "Không thể tải lịch sử đăng nhập.",
      "empty": "Không có lần đăng nhập nào trong khoảng thời gian này.",
      "pager": {
        "aria": "Phân trang",
        "pageSize": "Số dòng mỗi trang",
        "total": "{{total}} bản ghi",
        "prev": "Trước",
        "next": "Sau"
      }
    },
    "activity": {
      "viewLoginHistory": "Xem lịch sử đăng nhập"
    }
  },
  "auditLog": {
    "page": {
      "title": "Audit Log",
      "subtitle": "Nhật ký audit toàn hệ thống. Chỉ đọc, không thể chỉnh sửa."
    },
    "actions": {
      "exportCsv": "Xuất CSV",
      "view": "Xem",
      "loadMore": "Tải thêm",
      "loading": "Đang tải…"
    },
    "columns": {
      "timestamp": "Thời điểm",
      "actor": "Người thực hiện",
      "action": "Hành động",
      "entity": "Đối tượng",
      "details": "Chi tiết"
    },
    "loading": "Đang tải audit log…",
    "empty": {
      "title": "Không có log entry nào",
      "body": "Thử điều chỉnh bộ lọc hoặc mở rộng khoảng thời gian."
    },
    "footer": {
      "showing_one": "Đang hiển thị {{count}} mục",
      "showing_other": "Đang hiển thị {{count}} mục",
      "loadingMore": " • đang tải thêm…"
    },
    "drawer": {
      "title": "Mục audit — {{action}}",
      "close": "Đóng"
    },
    "fields": {
      "timestamp": "Thời điểm",
      "actor": "Người thực hiện",
      "action": "Hành động",
      "entity": "Đối tượng",
      "requestId": "Request ID",
      "merchantId": "Merchant ID",
      "ip": "IP",
      "userAgent": "User Agent"
    },
    "json": {
      "oldValue": "Giá trị cũ",
      "newValue": "Giá trị mới",
      "metadata": "Metadata"
    },
    "relative": {
      "seconds": "{{count}}s trước",
      "minutes": "{{count}}m trước",
      "hours": "{{count}}h trước",
      "days": "{{count}}d trước",
      "months": "{{count}}mo trước",
      "years": "{{count}}y trước"
    },
    "filters": {
      "actorLabel": "Email người thực hiện",
      "actorPlaceholder": "tìm theo email…",
      "searchLabel": "Tìm kiếm",
      "searchPlaceholder": "tìm hành động, ID đối tượng, email…",
      "searchAria": "Tìm kiếm tự do",
      "clear": "Xoá bộ lọc",
      "dateRange": "Khoảng thời gian",
      "from": "Từ",
      "to": "Đến",
      "action": "Hành động",
      "entityType": "Loại đối tượng"
    },
    "presets": {
      "7d": "7 ngày qua",
      "30d": "30 ngày qua",
      "90d": "90 ngày qua",
      "custom": "Khoảng tuỳ chỉnh"
    },
    "toast": {
      "loadFailTitle": "Không tải được audit log",
      "unknown": "Không xác định"
    }
  },
  "audit": {
    "loading": "Đang tải audit log…",
    "empty": {
      "title": "Không có log entry nào",
      "body": "Thử điều chỉnh bộ lọc hoặc mở rộng khoảng thời gian."
    },
    "errors": {
      "loadFailed": "Không thể tải audit log"
    },
    "columns": {
      "timestamp": "Thời điểm",
      "actor": "Người thực hiện",
      "role": "Vai trò",
      "entity": "Đối tượng",
      "entityId": "ID đối tượng",
      "action": "Hành động",
      "ip": "IP",
      "userAgent": "User Agent",
      "diff": "Thay đổi",
      "severity": "Mức độ"
    },
    "filters": {
      "action": "Hành động",
      "allActions": "— Tất cả hành động —",
      "entityType": "Loại đối tượng",
      "allEntities": "— Tất cả 24 đối tượng —",
      "actorUserId": "ID người thực hiện",
      "actorUserIdPlaceholder": "ObjectId (24 hex)",
      "actorRole": "Vai trò người thực hiện",
      "all": "— Tất cả —",
      "severity": "Mức độ",
      "dateFrom": "Từ ngày",
      "dateTo": "Đến ngày",
      "search": "Tìm kiếm (q)",
      "searchPlaceholder": "Hành động/đối tượng/IP/UA…",
      "clear": "Xoá toàn bộ bộ lọc"
    },
    "footer": {
      "showing_one": "Đang hiển thị {{count}} mục",
      "showing_other": "Đang hiển thị {{count}} mục",
      "loadingMore": " • đang tải thêm…"
    },
    "actions": {
      "loadMore": "Tải thêm",
      "loading": "Đang tải…"
    },
    "relativeAgo": "{{value}} trước",
    "diff": {
      "changesAria_one": "{{count}} thay đổi",
      "changesAria_other": "{{count}} thay đổi",
      "viewTooltip": "Bấm để xem diff",
      "noChanges": "Sự kiện này không thay đổi dữ liệu (không có diff để hiển thị).",
      "columnField": "Trường (key-path)",
      "columnBefore": "Trước",
      "columnAfter": "Sau",
      "collapse": "Thu gọn",
      "expandAll": "Xem tất cả ({{count}} phần tử)",
      "truncated": "Diff bị cắt bớt — chỉ hiển thị 50 trường đầu tiên. Mở \"Xem JSON đầy đủ\" để xem toàn bộ payload.",
      "showJson": "Xem JSON đầy đủ",
      "hideJson": "Ẩn JSON đầy đủ",
      "rawBefore": "Trước (raw)",
      "rawAfter": "Sau (raw)",
      "kind": {
        "added": "+ Đã thêm",
        "removed": "- Đã xoá",
        "modified": "~ Đã sửa",
        "unchanged": "= Không đổi"
      }
    },
    "multiSelect": {
      "all": "— Tất cả —",
      "selectedCount": "{{count}} đã chọn",
      "filterPlaceholder": "Lọc tuỳ chọn…",
      "noMatch": "Không khớp tuỳ chọn nào",
      "clearAll": "Bỏ chọn tất cả",
      "close": "Đóng"
    },
    "archive": {
      "bannerTitle": "Đang tìm trong cold storage (S3) — kết quả có thể mất tới 30 giây.",
      "bannerBody": "Chỉ hiển thị bản ghi cũ hơn 180 ngày. Dữ liệu cá nhân (PII) đã được ẩn danh trước khi trả về.",
      "dateFrom": "Từ ngày *",
      "dateTo": "Đến ngày *",
      "actorPlaceholder": "ObjectId / đã ẩn danh",
      "searchPlaceholder": "Truy vấn tự do — hành động/đối tượng/ip…",
      "scanning": "Đang quét S3",
      "estimate": " (~{{seconds}}s)",
      "runButton": "Tìm trong cold storage",
      "unavailable": "Cold storage tạm thời không khả dụng",
      "idlePrefix": "Chọn khoảng thời gian (cũ hơn 180 ngày) và bấm ",
      "idleSuffix": " để bắt đầu.",
      "pseudonymized": "Đã ẩn danh PII",
      "scanned_one": "Đã quét {{count}} S3 object",
      "scanned_other": "Đã quét {{count}} S3 object",
      "searching": "Đang tìm trong cold storage…",
      "empty": "Không tìm thấy bản ghi nào trong cold storage cho khoảng thời gian này."
    },
    "actionLabels": {
      "AUTH_USER_UPDATE": "Người dùng — Cập nhật",
      "AUTH_PROFILE_UPDATE": "Hồ sơ — Cập nhật",
      "AUTH_USER_SUSPEND": "Người dùng — Tạm khóa",
      "AUTH_USER_UNSUSPEND": "Người dùng — Bỏ tạm khóa",
      "AUTH_USER_ROLE_GRANT": "Người dùng — Cấp vai trò",
      "AUTH_USER_ROLE_REVOKE": "Người dùng — Thu hồi vai trò",
      "AUTH_2FA_SETUP": "2FA — Thiết lập",
      "AUTH_2FA_DISABLED": "2FA — Vô hiệu hóa",
      "AUTH_2FA_VERIFY": "2FA — Xác minh",
      "AUTH_USER_2FA_RESET": "2FA — Admin đặt lại",
      "AUTH_BILLING_UPDATE": "Thanh toán — Cập nhật",
      "AUTH_LOGIN_FAILED": "Xác thực — Đăng nhập thất bại",
      "AUTH_LOGIN_LOCKED": "Xác thực — Khóa đăng nhập",
      "ADMIN_ROLE_CREATE": "Vai trò — Tạo",
      "ADMIN_ROLE_UPDATE": "Vai trò — Cập nhật",
      "ADMIN_ROLE_DELETE": "Vai trò — Xóa",
      "AUTH_LOGIN": "Xác thực — Đăng nhập",
      "AUTH_LOGOUT": "Xác thực — Đăng xuất",
      "AUTH_REGISTER": "Xác thực — Đăng ký",
      "AUTH_OTP_VERIFY": "Xác thực — Xác minh OTP",
      "AUTH_OTP_RESEND": "Xác thực — Gửi lại OTP",
      "AUTH_PASSWORD_CHANGE": "Xác thực — Đổi mật khẩu",
      "AUTH_PASSWORD_RESET": "Xác thực — Đặt lại mật khẩu",
      "AUTH_PASSWORD_RESET_REQUESTED": "Xác thực — Yêu cầu đặt lại mật khẩu",
      "AUTH_REFRESH": "Xác thực — Làm mới token",
      "AUTH_TOKEN_REUSE": "Xác thực — Phát hiện tái sử dụng token",
      "AUTH_OAUTH_LOGIN_INITIATED": "Xác thực — Bắt đầu đăng nhập OAuth",
      "AUTH_OAUTH_CALLBACK_SUCCESS": "Xác thực — OAuth callback thành công",
      "AUTH_OAUTH_CALLBACK_FAILED": "Xác thực — OAuth callback thất bại",
      "AUTH_SIGNUP_COUNTRY_MISMATCH": "Xác thực — Quốc gia đăng ký không khớp",
      "AUTH_SURVEY_SUBMIT": "Xác thực — Gửi khảo sát",
      "AUTH_IMPERSONATE_START": "Đóng vai — Bắt đầu",
      "AUTH_IMPERSONATE_END": "Đóng vai — Kết thúc",
      "AUTH_IMPERSONATE_LANDING": "Đóng vai — Trang đích",
      "AUTH_EMERGENCY_MODE_ACTIVATE": "Đóng vai — Chế độ khẩn cấp",
      "SETUP_INIT": "Thiết lập — Khởi tạo",
      "SETUP_COMPLETED": "Thiết lập — Hoàn tất",
      "AUTH_TEAM_INVITE": "Nhóm — Mời",
      "AUTH_TEAM_INVITE_COMPLETE": "Nhóm — Hoàn tất lời mời",
      "AUTH_TEAM_SUSPEND": "Nhóm — Đình chỉ",
      "AUTH_TEAM_UNSUSPEND": "Nhóm — Bỏ đình chỉ",
      "AUTH_TEAM_REASSIGN": "Nhóm — Phân công lại",
      "MEMBER_SOFT_DELETED": "Thành viên — Đã xoá mềm",
      "MEMBER_UPDATED": "Thành viên — Đã cập nhật",
      "LIMIT_REQUEST_SUBMITTED": "Yêu cầu hạn mức — Đã gửi",
      "LIMIT_REQUEST_APPROVED": "Yêu cầu hạn mức — Đã duyệt",
      "LIMIT_REQUEST_REJECTED": "Yêu cầu hạn mức — Đã từ chối",
      "LIMIT_REQUEST_CANCELLED": "Yêu cầu hạn mức — Đã huỷ",
      "TWO_FA_RESET_BY_ADMIN": "2FA — Admin đặt lại",
      "CASHBACK_CREDIT": "Thanh toán — Hoàn tiền cashback",
      "REFUND_CREATE": "Thanh toán — Tạo hoàn tiền",
      "INTERNAL_AUTH_REJECTED": "Nội bộ — Từ chối xác thực"
    },
    "entityTypeLabels": {
      "User": "Người dùng",
      "Team": "Nhóm",
      "TeamMember": "Thành viên nhóm",
      "Merchant": "Merchant",
      "Role": "Vai trò",
      "Permission": "Quyền",
      "LimitRequest": "Yêu cầu hạn mức",
      "TopupRequest": "Yêu cầu nạp tiền",
      "WithdrawRequest": "Yêu cầu rút tiền",
      "Chargeback": "Chargeback",
      "Wallet": "Ví",
      "Session": "Phiên",
      "Orders": "Đơn hàng",
      "Users": "Người dùng (nhân viên admin)",
      "Products": "Sản phẩm",
      "Finance": "Tài chính",
      "Merchants": "Merchant",
      "Vendors": "Vendor",
      "Stores": "Cửa hàng",
      "SupportTickets": "Ticket hỗ trợ",
      "Settings": "Cài đặt hệ thống",
      "FeatureFlags": "Feature flag",
      "KYCDocuments": "Tài liệu KYC",
      "Payouts": "Chi trả",
      "ImpersonationSessions": "Phiên đóng vai",
      "ApprovalRequests": "Yêu cầu phê duyệt",
      "Addons": "Tiện ích bổ sung",
      "BlueprintsAdmin": "Blueprint (admin)",
      "Bundles": "Gói",
      "Categories": "Danh mục",
      "Collections": "Bộ sưu tập",
      "CreditMemos": "Giấy báo có",
      "LegalEntities": "Pháp nhân",
      "PendingApprovals": "Phê duyệt chờ xử lý",
      "PrepaymentRequests": "Yêu cầu trả trước",
      "Pricing": "Định giá",
      "ProductsSpecial": "Sản phẩm đặc biệt",
      "RefundTasks": "Tác vụ hoàn tiền",
      "RegionErrors": "Lỗi khu vực",
      "Templates": "Mẫu",
      "Techniques": "Kỹ thuật",
      "Tickets": "Ticket",
      "TicketMessages": "Tin nhắn ticket",
      "RoleChanges": "Thay đổi vai trò",
      "APIKeyAccess": "Truy cập API key",
      "PermissionGrants": "Cấp quyền",
      "EmergencyMode": "Chế độ khẩn cấp",
      "AuditExport": "Xuất audit",
      "RetentionConfig": "Cấu hình lưu giữ",
      "CustomRoleCRUD": "CRUD vai trò tùy chỉnh",
      "FeatureFlagChanges": "Thay đổi feature flag",
      "Inventory": "Tồn kho",
      "MerchantTransferBlock": "Chặn chuyển merchant"
    },
    "actorRoleLabels": {
      "superadmin": "Super admin",
      "admin": "Admin",
      "support_admin": "Admin hỗ trợ",
      "accountant": "Kế toán",
      "system": "Hệ thống"
    },
    "severityLabels": {
      "info": "Thông tin",
      "warning": "Cảnh báo",
      "security": "Bảo mật"
    }
  },
  "dualApproval": {
    "reasonTooShort": "Lý do phải có ít nhất 10 ký tự.",
    "actionTypes": {
      "refund_large": "Hoàn tiền (lớn)",
      "vendor_wallet_debit_large": "Trừ ví vendor (lớn)",
      "force_cancel_large": "Buộc hủy (lớn)",
      "bulk_suspend_merchants": "Tạm ngưng hàng loạt merchant",
      "bulk_delete": "Xóa hàng loạt",
      "gateway_key_rotation": "Xoay khóa cổng thanh toán",
      "maintenance_mode_toggle": "Chế độ bảo trì",
      "feature_flag_prod_toggle": "Cờ tính năng (production)",
      "kek_rotation": "Xoay khóa KEK",
      "audit_log_export": "Xuất nhật ký kiểm toán",
      "impersonate_to_superadmin": "Đóng vai Super Admin",
      "credit_grant_large": "Cấp tín dụng (lớn)",
      "pricing_tier_change_large": "Đổi bậc giá (lớn)",
      "weight_formula_change": "Đổi công thức trọng lượng",
      "credit_memo_approve": "Duyệt credit memo"
    },
    "statusLabels": {
      "pending": "Chờ duyệt",
      "approved": "Đã duyệt",
      "executed": "Đã thực thi",
      "rejected": "Đã từ chối",
      "expired": "Hết hạn"
    },
    "card": {
      "initiatedBy": "Khởi tạo bởi",
      "reasonLabel": "Lý do:",
      "payloadPreview": "Xem trước payload",
      "approvalsProgress": "{{n}} / {{required}} phê duyệt",
      "singleSaExemption": "Miễn trừ Single-SA",
      "singleSaExemptionTooltip": "Theo, Super Admin duy nhất đang hoạt động có thể tự duyệt theo diện miễn trừ",
      "threshold": "Ngưỡng {{currency}} {{amount}}",
      "revalidating": "Đang xác thực lại…",
      "revalidateDiff": "Xác thực lại khác biệt",
      "revalidateError": "Lỗi xác thực lại",
      "revalDiffTitle": "Khác biệt xác thực lại — yêu cầu so với trạng thái hiện tại",
      "close": "Đóng",
      "diffHighlightTitle": "Đánh dấu thay đổi kể từ khi khởi tạo",
      "noEffectiveState": "Chưa có dữ liệu trạng thái thực tế — bấm Xác thực lại để tải.",
      "selfApproveNotice": "Bạn là người khởi tạo yêu cầu — không thể tự duyệt.",
      "alreadyVoted": "Bạn đã bỏ phiếu cho yêu cầu này.",
      "approveCommentLabel": "Nhận xét khi duyệt (tối thiểu 10 ký tự)",
      "approveCommentPlaceholder": "Lý do duyệt (≥10 ký tự)",
      "approving": "Đang duyệt…",
      "approve": "Duyệt",
      "reject": "Từ chối",
      "rejectReasonLabel": "Lý do từ chối (tối thiểu 10 ký tự)",
      "rejectReasonPlaceholder": "Lý do từ chối yêu cầu này (≥10 ký tự)",
      "rejecting": "Đang từ chối…",
      "confirmReject": "Xác nhận từ chối"
    },
    "emergencyBar": {
      "title": "Chế độ khẩn cấp đang bật",
      "scopeLabel": "Phạm vi:",
      "autoExpires": "Tự hết hạn sau {{countdown}}",
      "aborting": "Đang hủy…",
      "abort": "Hủy bỏ",
      "scope": {
        "production": "Production (đơn hàng + thanh toán)",
        "security": "Security (phiên + KEK + IP)",
        "maintenance": "Maintenance (cron + worker)"
      }
    }
  },
  "security": {
    "severityLabels": {
      "low": "Thấp",
      "medium": "Trung bình",
      "high": "Cao",
      "critical": "Nghiêm trọng"
    },
    "statusLabels": {
      "open": "Mới",
      "dismissed": "Đã bỏ qua",
      "resolved": "Đã xử lý"
    },
    "cancel": "Hủy",
    "anomaly": {
      "title": "Cảnh báo bất thường",
      "totalAria": "Tổng số sự kiện: {{total}}",
      "eventCount_one": "{{count}} sự kiện",
      "eventCount_other": "{{count}} sự kiện",
      "severityFilter": "Mức độ",
      "statusFilter": "Trạng thái",
      "all": "Tất cả",
      "refresh": "Làm mới",
      "loadError": "Không thể tải danh sách cảnh báo.",
      "dismissError": "Không thể bỏ qua sự kiện.",
      "loading": "Đang tải...",
      "empty": "Không có cảnh báo nào.",
      "dismiss": "Bỏ qua",
      "prev": "Trước",
      "next": "Sau",
      "pageInfo": "Trang {{page}} / {{totalPages}} — {{total}} sự kiện",
      "columns": {
        "time": "Thời điểm",
        "rule": "Luật",
        "severity": "Mức độ",
        "actor": "Đối tượng",
        "sourceIp": "IP nguồn",
        "status": "Trạng thái",
        "actions": "Hành động"
      },
      "dismissDialog": {
        "title": "Bỏ qua cảnh báo",
        "bodyBefore": "Nhập lý do bỏ qua sự kiện ",
        "bodyAfter": ". Hành động sẽ được ghi vào nhật ký kiểm toán.",
        "reasonLabel": "Lý do (tối thiểu 10 ký tự)",
        "saving": "Đang lưu...",
        "confirm": "Xác nhận bỏ qua"
      }
    },
    "emergency": {
      "title": "Emergency Mode (Chế độ khẩn cấp)",
      "subtitle": "Chỉ Super Admin được kích hoạt. Yêu cầu mã 2FA. Tự hết hạn sau 2 giờ.",
      "activeBadge": "ĐANG BẬT — {{scope}}",
      "inactiveBadge": "Chưa kích hoạt",
      "activatedBy": "Người kích hoạt",
      "startedAt": "Bắt đầu",
      "autoExpiresAt": "Tự hết hạn",
      "remaining": "Còn lại",
      "allowedActions": "Hành động được phép:",
      "abortNow": "Abort ngay",
      "normalState": "Hệ thống đang hoạt động bình thường — không có Emergency Mode nào đang active.",
      "activateBtn": "Kích hoạt Emergency Mode",
      "superAdminOnly": "Chỉ Super Admin có quyền kích hoạt.",
      "expired": "Đã hết hạn",
      "activateError": "Không thể kích hoạt Emergency Mode.",
      "abortError": "Không thể abort Emergency Mode.",
      "activateTitle": "Kích hoạt Emergency Mode",
      "activateBody": "Hành động này sẽ thay đổi cấu hình bảo mật toàn hệ thống. Yêu cầu mã 2FA. Tự hết hạn sau 2 giờ. Mọi thao tác đều ghi audit log.",
      "scopeField": "Phạm vi",
      "totpLabel": "Mã 2FA (6 chữ số)",
      "reasonLabel20": "Lý do (≥ 20 ký tự)",
      "activating": "Đang kích hoạt...",
      "confirmActivate": "Xác nhận kích hoạt",
      "abortTitle": "Abort Emergency Mode",
      "abortBody": "Thao tác này sẽ vô hiệu hóa ngay lập tức. Audit log sẽ ghi nhận lý do.",
      "reasonLabel10": "Lý do (≥ 10 ký tự)",
      "aborting": "Đang abort...",
      "confirmAbort": "Xác nhận abort",
      "scopeLabels": {
        "production": "Production — chặn ghi dữ liệu phi-critical",
        "security": "Security — bulk IP block + force revoke sessions",
        "maintenance": "Maintenance — chặn merchant/vendor write"
      }
    }
  },
  "emailTemplates": {
    "testSend": {
      "ariaLabel": "Gửi thử mẫu email",
      "title": "Gửi thử mẫu",
      "bodyBefore": "Kết xuất ",
      "bodyAfter": " với dữ liệu mẫu và gửi tới một địa chỉ QA.",
      "langLabel": "Ngôn ngữ",
      "toEmailLabel": "Email người nhận",
      "payloadLabel": "Dữ liệu mẫu (JSON)",
      "sending": "Đang gửi…",
      "sendTest": "Gửi thử",
      "cancel": "Huỷ",
      "errPayloadObject": "Sample payload phải là một object JSON.",
      "errPayloadJson": "JSON không hợp lệ — kiểm tra cú pháp.",
      "errEmailRequired": "Vui lòng nhập email người nhận.",
      "errMissingVars": "Thiếu biến bắt buộc: {{vars}}",
      "toastSuccessTitle": "Đã gửi test mail",
      "toastSuccessDesc": "Tới {{email}} • message_id {{messageId}}…",
      "toastFailTitle": "Gửi test mail thất bại",
      "toastUnknownError": "Lỗi không xác định. Vui lòng thử lại."
    }
  },
  "upload": {
    "networkError": "Không thể kết nối đến máy chủ.",
    "failed": "Tải tệp lên thất bại."
  }
}
